import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

import ClubFeedPopupFooter from '../../../shared/components/club_feed_popup_footer'
import { clubFeedChannelsMessage } from '../../../shared/club_feed_channels'
import { clubFeedPopupFields } from '../../column_helpers'
import PopupTypes from '../../popup_types'

const t = (key) => (window.I18n ? window.I18n.t(key) : '')

class ExistingTimesPopup extends Component {
  constructor(props){
    super(props)
    this.onClose = props.onClose.bind(this, PopupTypes.EXISTING_TIMES)
    this.handleSave = this.handleSave.bind(this)
  }

  handleSave() {
    this.props.onSave(this.props.data)
    this.onClose()
  }

  render() {
    const clubFeed = clubFeedPopupFields(this.props.data)
    const message = clubFeedChannelsMessage(clubFeed.action, clubFeed.channels, clubFeed.product)

    return (
      <Modal
        show={ this.props.show }
        onHide={ this.onClose }
        dialogClassName="modal-md club_feed_existing_times_popup"
        aria-label={ t('leagues.existing_times.manually_opening') }
      >
        <div className="modal-body">
          <div>{ t('leagues.existing_times.manually_opening') }</div>
          { message && <div>{ message }</div> }
          <div>{ t('leagues.existing_times.want_to_continue') }</div>
          { message && (
            <ClubFeedPopupFooter settingsUrl={ clubFeed.settingsUrl }
                                 learnMoreUrl={ clubFeed.learnMoreUrl }
                                 compact />
          ) }
          <fieldset className="submit_bar add-margin-top-30">
            <button type="button"
                    className="btsp_orange_button save_button btn pull-right"
                    onClick={ this.handleSave }
            >
              { t('leagues.existing_times.continue') }
            </button>
            <button type="button"
                    className="btsp_gray_button pull-right"
                    onClick={ this.onClose }
            >
              { t('leagues.existing_times.cancel') }
            </button>
          </fieldset>
        </div>
      </Modal>
    )
  }
}

ExistingTimesPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default ExistingTimesPopup
